/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:fixed;height:67px;width:100%;background:#ffefed;z-index:2;display:flex;justify-content:center;align-items:center;padding:0 2rem;top:0}[_nghost-%COMP%]   .alert-text[_ngcontent-%COMP%]{color:#ba0419}[_nghost-%COMP%]   .alert-text[_ngcontent-%COMP%]   a.underlined[_ngcontent-%COMP%]{text-decoration:underline}[_nghost-%COMP%]   img.warning-icon[_ngcontent-%COMP%]{width:22px;height:19px;margin-right:1rem;flex-shrink:0}@media (max-width:468px){[_nghost-%COMP%]{height:90px}}"];
export { styles as styles };
